import React from "react";
import { IdentificationIcon } from "@heroicons/react/solid";

const JavaLogo = require("../assets/logos/java.png");
const ReactLogo = require("../assets/logos/ReactLogo.png");
const csslogo = require("../assets/logos/csslogo.png");
const JsLogo = require("../assets/logos/JsLogo.png");
const HTMLlogo = require("../assets/logos/html-logo.png");
const wplogo = require("../assets/logos/wp-logo.png");
const SqlLogo = require("../assets/logos/SqlLogo.png");
const Angularlogo = require("../assets/logos/angularlogo.png");
const FirebaseLogo = require("../assets/logos/FirebaseLogo.png");
const phplogo = require("../assets/logos/php.png");
const ShopifyLogo = require("../assets/logos/shopifylogo.png");
const sasslogo = require("../assets/logos/sasslogo.png");

const About = () => {
  return (
    <div
      id="About"
      className="mx-12 mt-60 lg:mx-60 items-center justify-center lg:w-1/2 text-justify"
    >
      <div>
        <div className="table">
          <IdentificationIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
          <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
            About Me
          </code>
          <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
        </div>
        <div className="text-[#a2aabc] text-lg mt-5">
          <code>
          I have been passionate about computer science since I was a child. I undertook a high school course in Computer Science and Telecommunications and then continued 
          my studies at the JOBS Academy Foundation where I obtained a fifth degree diploma in Web Design & Software Development.
          I use my creativity and my imagination to create designs that are always new, modern and that satisfy customer requests.
          </code>
          <br />
          <br />
          
          <div className="grid grid-cols-3 gap-2 text-sm mt-5 text-brown_vs">
          <div className="flex flex-row mb-3">
              <img
                src={HTMLlogo}
                alt="HTML Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>HTML</code>
            </div>
            <div className="flex flex-row  mb-3">
              <img
                src={JsLogo}
                alt="Js Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>JavaScript (ES6+)</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={ReactLogo}
                alt="React Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>React</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={csslogo}
                alt="css Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>CSS</code>
            </div>
            <div className="flex flex-row  mb-3">
              <img
                src={wplogo}
                alt="Tailwind Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Wordpress</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={Angularlogo}
                alt="Redux Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Angular</code>
            </div>
            <div className="flex flex-row  mb-3">
              <img
                src={JavaLogo}
                alt="Java Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>JAVA</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={FirebaseLogo}
                alt="Firebase Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Firebase</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={sasslogo}
                alt="sass Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>SASS</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={ShopifyLogo}
                alt="NodeJS Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>Shopify</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={SqlLogo}
                alt="SQL Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>SQL</code>
            </div>
            <div className="flex flex-row mb-3">
              <img
                src={phplogo}
                alt="php Logo"
                className="h-5 w-5 ml-3 mr-4 text-yellow_vs"
              />
              <code>PHP</code>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    
  );
};

export default About;
